import {ErrorBoundary} from "react-error-boundary";
import styled from "styled-components";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../../styles/dashboard/calls/calls";
import {Alert, Breadcrumb, Button} from "antd";
import {StyledHideStepsOnMobile} from "../../../../../components/offering-form/general/steps/styles";
import {CanvaTemplateWidget} from "../../../../../components/widgets/canva-template-widget";
import {CreateSubscriptionFormSteps} from "../../../../../subscriptions-feature/useCases/create-subscription/multi-step/create-subscription-steps";
import {CreateSubscriptionMultiStepFormWrapper} from "../../../../../subscriptions-feature/useCases/create-subscription/multi-step/multi-step-form-wrapper";
import {CreateSubscriptionContextWrapper} from "../../../../../subscriptions-feature/useCases/create-subscription/context/create-subscription/context-wrapper";
import {Link} from "react-router-dom";

/** Tighter stack on mobile so horizontal/vertical rhythm matches edit subscription (tabs layout). */
const StyledSubscriptionCreatePageWrapper = styled(StyledPageWrapper)`
  @media only screen and (max-width: 1023px) {
    gap: 1.5rem;
    margin-top: 1rem;
  }
`;

export function SubscriptionCreationPage() {
  return (
    <DashboardWrapper pageTitle="Create a new subscription">
      <CreateSubscriptionContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/products?activeTab=subscriptions">Subscriptions</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create new subscription</Breadcrumb.Item>
        </Breadcrumb>
        <StyledSubscriptionCreatePageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              )}
            >
              <CreateSubscriptionMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateSubscriptionFormSteps />
            </StyledHideStepsOnMobile>
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGPzxhigYA/gFsU5XQQ4j5DlxQnccruhg/view?utm_content=DAGPzxhigYA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </div>
        </StyledSubscriptionCreatePageWrapper>
      </CreateSubscriptionContextWrapper>
    </DashboardWrapper>
  );
}
